import { render, staticRenderFns } from "./UnassignEditorForm.vue?vue&type=template&id=ac60a390"
import script from "./UnassignEditorForm.vue?vue&type=script&lang=ts"
export * from "./UnassignEditorForm.vue?vue&type=script&lang=ts"
import style0 from "./UnassignEditorForm.vue?vue&type=style&index=0&id=ac60a390&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports